import React from 'react';
import { Link } from 'react-router-dom';
import Text from '@bit/knotchinc.web-react-components.text';
import { Icon } from './styled';

const ITEM_COUNT = 5;

const EntityIconList = ({ type, data }) => {
  const entityURL = (entityType, entityId) => `/blueprint/${entityType}/${entityId}`;
  const iconList = data.slice(0, ITEM_COUNT).map((entity, index) =>
    <Icon
      key={`icon_${index}_entity_public_id`}
      logo_url={entity.logo_url}
      as={Link}
      to={entityURL(type, entity.public_id)}
    />);
  return (
    <React.Fragment>
      {iconList}
      {data.length > ITEM_COUNT && <Text color="#939AAB" pl="3px" display="inline-block">{`+ ${data.length - ITEM_COUNT}`}</Text>}
    </React.Fragment>
  );
};

export default EntityIconList;
